import { render, staticRenderFns } from "./AccountFranchisorStepCard.vue?vue&type=template&id=6c6858bd&scoped=true&"
import script from "./AccountFranchisorStepCard.vue?vue&type=script&lang=js&"
export * from "./AccountFranchisorStepCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountFranchisorStepCard.vue?vue&type=style&index=0&id=6c6858bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6858bd",
  null
  
)

export default component.exports